import React, {FC} from 'react';
import {Button} from 'reactstrap';
import {Link} from 'react-router-dom';

import CodesTable from '../code/codes-table';
import routes, {getRoute} from "~/route-map";
import {useSelector} from "react-redux";
import Selectors from "~/state/selectors.ts";

export const AccountingCodesListPage: FC = () => {
    const codes = useSelector(Selectors.getCodes);
    const cnum: string = useSelector(Selectors.getCustomerNumber);
    const ctx: string = useSelector(Selectors.getAppContext);

    const mainUrl: string = getRoute(routes.app.base, {cnum, ctx});

    return (
        <React.Fragment>
            <div className="text-right mb-2">
                    <span className="d-inline-block">
                        <Button color="primary" tag={Link} to={`${mainUrl}/ac/codes/add`}>Add Code</Button>
                    </span>
            </div>
            <CodesTable codes={codes}/>
        </React.Fragment>
    );
}

export default AccountingCodesListPage;
